<template>
  <div class="personal-r">
    <h2>历史充值</h2>
    <table class="table-list column5">
      <tr>
        <th>卡号</th>
        <th>对应产品</th>
        <th>使用期限</th>
        <th>支付日期</th>
        <th>订单号</th>
      </tr>
      <tr v-for="(item, index) in cardList" :key="index">
        <td>{{item.id}}</td>
        <td>{{item.productName}}</td>
        <td>{{item.monthCount}}个月</td>
        <td>{{item.chargeTime | dateFormat("yyyy-MM-dd")}}</td>
        <td>{{item.paymentId}}</td>
      </tr>
    </table>
    <p class="no-record" v-if="cardList == null || cardList.length == 0">暂无记录</p>
  </div>
</template>

<script>
export default {
  name: "CardList",
  data() {
    return {
      cardList: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("/card/list")
        .then(response => {
          if (response.code === 0) {
            this.cardList = response.data;
          } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/personal.scss";
.column5 {
  th,
  td {
    &:first-child {
      width: 100px;
      padding: 0 45px 0 35px;
    }
    &:nth-child(2) {
      width: 300px;
    }
    &:nth-child(3) {
      width: 140px;
    }
    &:nth-child(4) {
      width: 140px;
    }
  }
}
.no-record {
  @include fc(20px, #222);
  @include vertical-center(100%, 30px);
}
</style>



// WEBPACK FOOTER //
// src/pages/personal/CardList.vue